
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { AxiosResponse } from "axios";
import { Watch } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";

import { PaginationState } from "@/store/types";
import { SchoolModel } from "@/models/academy.model";
import { isUniversity } from "@/functions/userinterface.function";
import { CandidateModel } from "@/models/candidate.model";

import toast from "@/functions/toast.function";

@Component({
  filters: filters,
})
export default class CandidateInviteList extends Vue {
  // ACTION
  @Action("actionSelectCandidateInactive", { namespace: "candidate" })
  private actionSelectCandidateInactive: any;
  @Action("actionPaginationCandidateInactive", { namespace: "candidate" })
  private actionPaginationCandidateInactive: any;
  @Action("actionCandidateSaveEdit", { namespace: "candidate" })
  private actionCandidateSaveEdit: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: SchoolModel;
  @State("candidate", { namespace: "candidate" })
  private candidate: any;
  @State("array_candidate_inactive", { namespace: "candidate" })
  private array_candidate: Array<CandidateModel>;
  @State("pagination_candidate_inactive", { namespace: "candidate" })
  private pagination_candidate_inactive: PaginationState;

  // MUTATION
  @Mutation("mutationCandidate", { namespace: "candidate" })
  private mutationCandidate: any;

  // WATCH
  @Watch("showPopupEditCandidate")
  private onShowEdit(val: any) {
    if (!val) {
      this.mutationCandidate(new CandidateModel());
    }
  }

  // INITIALIZATION
  private onLoad: boolean = false;
  private showPopupEditCandidate: boolean = false;
  private activePage: number = 1;
  private formCandidate = {
    nim: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  };

  private get wordingStudentID() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("student_id_nisn_2");
    }

    return this.$i18n.t("student_id_nisn");
  }

  private get wordingEditStudentInfo() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("edit_student_info_2");
    }

    return this.$i18n.t("edit_student_info");
  }

  /* LIFECYCLE */
  private created() {
    this.resizeTab();
    this.actionSelectCandidateInactive({
      callback: (response: AxiosResponse) => {
        const self = this;
        $(document).ready(function() {
          // INFINITE SCROLL PAGINATION
          const tableCandidate = $("#TableCandidateList");
          if (tableCandidate.has('div').length > 0) {
            $("#TableCandidateList").scroll(function() {
              const scrollAny = ($(this).scrollTop() as number) + ($(this).innerHeight() as number);
              const scrollHeight = $(this)[0].scrollHeight;
              if (scrollAny >= scrollHeight) {
                if (!self.onLoad) {
                  if (self.array_candidate.length === 0) {
                    return;
                  }
                  if (self.onLoad) {
                    return;
                  }
                  if (self.pagination_candidate_inactive.url) {
                    self.activePage++;
                    self.clickPage(
                      self.activePage,
                      self.pagination_candidate_inactive.url
                    );
                  }
                }
              }
            });
          }
        });
      },
    });
  }

  private mounted() {
    this.resizeTab();
  }

  // METHOD
  private resizeTab() {
    const width = ($(document).width() as number) - ($("#cardProfile").width() as number) - 150;
    $(".tab-content").css("max-width", `${width}px`);
    $(window).on("resize", () => {
      const width = ($(document).width() as number) - ($("#cardProfile").width() as number) - 150;
      $(".tab-content").css("max-width", `${width}px`);
    });
  }

  private clickPage(page: number, url: string) {
    this.onLoad = true;
    this.actionPaginationCandidateInactive({
      url,
      page,
      callback: (response: AxiosResponse) => {
        this.onLoad = false;
      },
    });
  }

  private clickSearch() {
    this.actionSelectCandidateInactive();
  }

  private clickUpdate(data: CandidateModel) {
    this.mutationCandidate(data);
    this.formCandidate.nim = this.candidate.nim;
    this.formCandidate.first_name = this.candidate.user.first_name;
    this.formCandidate.last_name = this.candidate.user.last_name;
    this.formCandidate.email = this.candidate.user.email;
    this.formCandidate.phone = (this.candidate.phone as string).replace(
      /\s/g,
      ""
    );
    this.showPopupEditCandidate = true;
  }

  private get isValidPhone() {
    const isContainLetter = new RegExp(/^[A-Za-z]+$/);
    if (!isContainLetter.test(this.formCandidate.phone)) {
      const phoneFormat = new RegExp(
        /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g
      );
      return phoneFormat.test(this.formCandidate.phone);
    } else {
      return false;
    }
  }

  private resetForm() {
    this.formCandidate = {
      nim: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    };
  }

  private checkValid() {
    let is_valid = true;

    // BUG => https://developerx.atlassian.net/browse/CS-5330
    // Fixed on 11 Mar 2022.
    // Fixed by Risman Abdilah.
    // if (is_valid && !this.formCandidate.nim) {
    //   toast.warning(this.$t("warning_nim"));
    //   is_valid = false;
    //   return;
    // }

    if (is_valid && !this.formCandidate.first_name) {
      toast.warning(this.$t("warning_first_name"));
      is_valid = false;
      return;
    }
    if (is_valid && !this.formCandidate.email) {
      toast.warning(this.$t("warning_email"));
      is_valid = false;
      return;
    }

    if (this.formCandidate.phone) {
      if (is_valid && !this.isValidPhone) {
        toast.warning(this.$t("warning_phone_format"));
        is_valid = false;
        return false;
      }
    }

    this.saveCandidate();
  }

  private saveCandidate() {
    this.actionCandidateSaveEdit({
      id: this.candidate.id,
      params: this.formCandidate,
    }).then((res: any) => {
      this.mutationCandidate(new CandidateModel());
      this.resetForm();
      this.showPopupEditCandidate = false;
      this.clickSearch();
    });
  }

  private onReset() {
    this.mutationCandidate(new CandidateModel());
    (this.$refs.searchCandidateInvite as any).hide();
    this.actionSelectCandidateInactive();
    this.activePage = 1;
  }

  private onSearch() {
    this.activePage = 1;
    this.actionSelectCandidateInactive();
  }
}
